import { useEffect, useState } from "react";

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

    function handleBeforeInstallPrompt(e) {
      e.preventDefault();
      // Ignore on iOS or if already installed
      if (isIOS || isStandalone) return;
      setDeferredPrompt(e);
      setVisible(true);
    }

    function handleAppInstalled() {
      setVisible(false);
      setDeferredPrompt(null);
    }

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  if (!visible) return null;

  const onInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    try {
      await deferredPrompt.userChoice;
    } finally {
      setVisible(false);
      setDeferredPrompt(null);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.textWrapper}>
          <div style={styles.title}>Install UsmaApp</div>
          <div style={styles.subtitle}>Get a faster, full-screen app experience.</div>
        </div>
        <div style={styles.actions}>
          <button onClick={() => setVisible(false)} style={styles.secondaryBtn}>Later</button>
          <button onClick={onInstallClick} style={styles.primaryBtn}>Install</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    bottom: 16,
    right: 16,
    zIndex: 1000,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    pointerEvents: "none",
  },
  content: {
    width: 320,
    maxWidth: "min(360px, 94vw)",
    background: "#111",
    color: "#fff",
    borderRadius: 12,
    padding: "12px 14px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    gap: 12,
    pointerEvents: "auto",
  },
  textWrapper: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: 12,
    opacity: 0.8,
    marginTop: 2,
  },
  actions: {
    display: "flex",
    gap: 8,
  },
  secondaryBtn: {
    background: "transparent",
    color: "#bbb",
    border: "1px solid #333",
    borderRadius: 8,
    padding: "8px 10px",
    fontSize: 14,
  },
  primaryBtn: {
    background: "#1a73e8",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 12px",
    fontSize: 14,
  },
};
